import 'moment/locale/pt-br';

import { Col, Row, Typography } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

const LocalizacaoMotorista = ({ dataLocalizacao }) => (
  <Row gutter={12} align="middle">
    <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
      <Typography.Text>Cidade mais próxima:</Typography.Text>
      <Row>
        <Typography.Text strong style={{ fontSize: '20px' }}>
          {dataLocalizacao.cidade && dataLocalizacao.estado
            ? `${dataLocalizacao.cidade}-${dataLocalizacao.estado}`
            : 'Não informada'}
        </Typography.Text>
      </Row>
    </Col>
    <Col span={14} style={{ fontSize: '12px', textAlign: 'right' }}>
      <Typography.Text style={{ marginRight: '5px' }}>
        Última atualização:
      </Typography.Text>
      <Typography.Text>
        {dataLocalizacao.dataUltimoCheckIn
          ? moment(dataLocalizacao.dataUltimoCheckIn).format('LLL')
          : 'Não informado'}
      </Typography.Text>
      <Row style={{ float: 'right' }}>
        <Typography.Text>
          {dataLocalizacao.status === 'Embarcado'
            ? '(informação disponível por 48 horas)'
            : ''}
        </Typography.Text>
      </Row>
    </Col>
  </Row>
);

LocalizacaoMotorista.propTypes = {
  dataLocalizacao: PropTypes.shape({
    placa: PropTypes.string,
    cidade: PropTypes.string,
    estado: PropTypes.string,
    status: PropTypes.string,
    dataUltimoCheckIn: PropTypes.string,
  }),
};

LocalizacaoMotorista.defaultProps = {
  dataLocalizacao: {},
};
export default LocalizacaoMotorista;
